import { Dossier, Sections_dossier } from "shared/types/types";
import { calculCompletudeDossierOverall, calculCompletudeLocataire, calculCompletudeSectionGarant } from "features/documents";
import { useContext, useState } from "react";
import { FolderContext } from "features/documents";

export default function LeftNav({dossier, active, onSelect}:{ dossier: Dossier; active:Sections_dossier; onSelect:(s:Sections_dossier) => void;}){
    const { folder, tryRemoveFolder, tryGetFolder, tryChangeVisibility, tryAddFileToFolder, partners } = useContext(FolderContext);

    const locataireCompleteness = calculCompletudeLocataire(folder?.documents || []);
    // const garantsCompleteness = calculCompletudeSectionGarant(dossier.garants || []);
    const overallCompleteness = calculCompletudeDossierOverall(folder?.documents || [], dossier?.garants || []);
    
    const LocSectionComplete = locataireCompleteness === 100;
   // const GarantSectionComplete = garantsCompleteness === 100;

    const [isHovered, setIsHovered] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);

    return (
        <div style={{width: '280px',background: '#f8fafc',padding: '24px 0',borderRight: '1px solid #e2e8f0',minHeight: '100vh'}}>
            <div style={{padding: '0 24px', marginBottom: '32px'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px'}}>
                    <div style={{width: '48px',height: '48px',borderRadius: '50%',background: overallCompleteness === 100 ? '#10b981' : '#1956A8',color: 'white',display: 'flex',alignItems: 'center',justifyContent: 'center',fontWeight: 600,fontSize: '14px',position: 'relative'}}>
                        {overallCompleteness === 100 ? '✓' : `${Math.round(overallCompleteness)}%`}
                    </div>
                    <div>
                        <div style={{
                            color: overallCompleteness === 100 ? '#10b981' : '#ef4444',
                            fontSize: '12px',
                            textTransform: 'uppercase',
                            fontWeight: 600,
                            letterSpacing: '0.5px'
                        }}>
                            {overallCompleteness === 100 ? 'COMPLET' : 'INCOMPLET'}
                        </div>
                    </div>
                </div>
                <div style={{width: '100%',height: '8px',background: '#e5e7eb',borderRadius: '4px',overflow: 'hidden',marginBottom: '8px'}}>
                    <div style={{width: `${overallCompleteness}%`,height: '100%',background: overallCompleteness === 100 ? '#10b981' : '#1956A8',transition: 'width 0.5s ease-in-out'}}></div>
                </div>
            </div>
            <div>
                <button
                  onClick={() => onSelect(Sections_dossier.LOCATAIRE)}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "16px 24px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      border: "none",
                      width: "100%",
                      textAlign: "left",
                      borderRight:
                        active === Sections_dossier.LOCATAIRE
                          ? "3px solid #1956A8"
                          : "none",
                      background:
                        active === Sections_dossier.LOCATAIRE
                          ? "white"
                          : isHovered
                            ? "#E8EFFB" // 👈 hover color (light gray)
                            : "transparent",
                  }}
                >
                    <div style={{ width: "100%" }}>
                        <div
                          style={{
                              fontWeight: 600,
                              color:
                                active === Sections_dossier.LOCATAIRE
                                  ? "#1f2937"
                                  : "#374151",
                              fontSize: "14px",
                              marginBottom: "4px",
                          }}
                        >
                            Documents du Locataire
                        </div>

                        <div
                          style={{
                              color: LocSectionComplete ? "#10b981" : "#ef4444",
                              fontSize: "12px",
                              textTransform: "uppercase",
                              fontWeight: 600,
                              letterSpacing: "0.5px",
                              marginBottom: "8px",
                          }}
                        >
                            {LocSectionComplete ? "COMPLET" : "INCOMPLET"}
                        </div>

                        <div
                          style={{
                              width: "100%",
                              height: "6px",
                              background: "#e5e7eb",
                              borderRadius: "3px",
                              overflow: "hidden",
                          }}
                        >
                            <div
                              style={{
                                  width: `${locataireCompleteness}%`,
                                  height: "100%",
                                  background:
                                    locataireCompleteness === 100
                                      ? "#10b981"
                                      : "#1956A8",
                                  transition: "width 0.5s ease-in-out",
                              }}
                            ></div>
                        </div>
                    </div>

                    <div
                      style={{
                          color: "#6b7280",
                          fontSize: "16px",
                          marginLeft: "12px",
                      }}
                    >
                        →
                    </div>
                </button>

                <button
                  onClick={() => onSelect(Sections_dossier.GARANTS)}
                  onMouseEnter={() => setIsHovered2(true)}
                  onMouseLeave={() => setIsHovered2(false)}
                  style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "16px 24px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      border: "none",
                      width: "100%",
                      textAlign: "left",
                      borderRight:
                        active === Sections_dossier.GARANTS
                          ? "3px solid #1956A8"
                          : "none",
                      background:
                        active === Sections_dossier.GARANTS
                          ? "white"
                          : isHovered2
                            ? "#E8EFFB" // 👈 hover background color (light gray)
                            : "transparent",
                  }}
                >
                    <div style={{ width: "100%" }}>
                        <div
                          style={{
                              fontWeight: 600,
                              color:
                                active === Sections_dossier.GARANTS
                                  ? "#1f2937"
                                  : "#374151",
                              fontSize: "14px",
                              marginBottom: "4px",
                          }}
                        >
                            Garant(s)
                        </div>
                        <div
                          style={{
                              color: "#6b7280",
                              fontSize: "12px",
                              textTransform: "uppercase",
                              fontWeight: 600,
                              letterSpacing: "0.5px",
                              marginBottom: "8px",
                          }}
                        >
                            Optionnel
                        </div>

                        {/*
        <div style={{
          width: "100%",
          height: "6px",
          background: "#e5e7eb",
          borderRadius: "3px",
          overflow: "hidden",
        }}>
          <div
            style={{
              width: `${garantsCompleteness}%`,
              height: "100%",
              background: garantsCompleteness === 100 ? "#10b981" : "#3b82f6",
              transition: "width 0.5s ease-in-out",
            }}
          ></div>
        </div>
        */}
                    </div>

                    <div
                      style={{
                          color: "#6b7280",
                          fontSize: "16px",
                          marginLeft: "12px",
                      }}
                    >
                        →
                    </div>
                </button>
            </div>
        </div>
    );
}